var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1925 60.0434H30.8115V17.5485C30.8115 7.85674 38.5933 0 48.1925 0V60.0434Z",
    fill: "#1F7DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5381 0C62.1373 0 69.9191 7.86336 69.9191 17.5633V60.4384C60.3198 60.4384 52.5381 52.5751 52.5381 42.8751V0Z",
    fill: "#1F7DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.7158H13.1725C20.8278 32.7158 27.0337 38.9217 27.0337 46.5771C27.0337 54.2324 20.8278 60.4383 13.1725 60.4383H0V32.7158Z",
    fill: "#1F7DFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29431e-05 7.83583e-05H8.62979C16.2851 7.83583e-05 22.491 6.20597 22.491 13.8613C22.491 21.5167 16.2851 27.7226 8.62979 27.7226H6.29431e-05V7.83583e-05Z",
    fill: "#1F7DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.9f9ac43e7c59f98137270f1365267f06.svg";
export { ForwardRef as ReactComponent };